const UI_AT = {
  CLEAR_404_PATHNAME: 'CLEAR_404_PATHNAME',
  CLEAR_TOAST_MESSAGE: 'CLEAR_TOAST_MESSAGE',
  ERROR_TOAST_MESSAGE: 'ERROR_TOAST_MESSAGE',
  SUCCESS_TOAST_MESSAGE: 'SUCCESS_TOAST_MESSAGE',
  TOGGLE_PRIVATE_MESSAGING: 'TOGGLE_PRIVATE_MESSAGING',
} as const;

export default UI_AT;
